module.exports = __webpack_public_path__ + "a5f09e254706ddbc2bdc0b46de465652.ttf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Bold.ttf
// module id = 12
// module chunks = 0